module.exports = __webpack_public_path__ + "static/media/RachelGold.94dcf9e5.png";